/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import Header from "../../Header";

import Sidebar from "../../Sidebar";
import { Clock, MoreVertical, Activity } from "lucide-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";

import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import CountUp from "react-countup";
import {
  Dropdown,
  Table,
  Menu,
  DatePicker,
  Popover,
  Row,
  Col,
  Grid,
  Select,
  message,
  Button,
} from "antd";
import {
  health_img,
  morning_img_03,
  Queue,
  Arrival,
  Consult,
  Hold,
  Done,
  report_icon1,
  doctor_dashboard_04,
  report_icon2,
  report_icon3,
  report_icon4,
  blogimg2,
  blogimg6,
  blogimg10,
  blogimg4,
  blogimg12,
  blogimg8,
  profiles03,
  imagesend,
} from "../../imagepath";

import "react-calendar/dist/Calendar.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import {
  SearchOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import {
  getAppointments,
  updateAppointment,
} from "../../../services/receptionist/book appointment/bookappointment";
import MedicineViewModal from "./MedicineViewModal";
import { use } from "react";
const { useBreakpoint } = Grid;

const Pharmacy_Dashboard = () => {
  const screens = useBreakpoint();
  const isSmallScreen = !screens.md;

  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [stats, setStats] = useState([]);
  const [patient, setPatients] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState();
  const [statusUpdated, setStatusUpdated] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const doctorOptions = doctors.map((doc) => ({
    value: doc.id,
    label: doc.name + " " + doc.last_name,
  }));

  const [count, setCount] = useState({});

  const fetchAppointmens = async (doctor_id=0) => {
    try {
      console.log(
        "Fetching appointments for doctor_id:",
        doctor_id,
        selectedDate
      );
      const result = await getAppointments(
        doctor_id,
        selectedDate.format("YYYY-MM-DD")
      );
      if (result.success) {
        console.log("Formatted Data:", result);
        setPatients(result?.data);
        const filtered = result?.data?.filter(
          (item) => item?.status === selectedIndex
        );
        setFilteredPatients(filtered);
        setCount({
          Queue: result?.data?.filter((item) => item?.status === "Done")
            .length,
          Done: result?.data?.filter((item) => item?.status === "Done").length,
          total: result?.data?.length,
        });

        setStatusUpdated(false);
      } else {
        console.error("Error:", result.error || "Failed to fetch Appointments");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchAppointmens();
  }, [selectedDoctor, statusUpdated, selectedDate, refresh]);

  const [selectedIndex, setSelectedIndex] = useState("Arrival");
  useEffect(() => {
    setOnSelectedIndex(selectedIndex);
  }, [selectedIndex]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const setOnSelectedIndex = (index) => {
    setSelectedIndex(index);
    console.log("Selected Index:", index);
    const filtered = patient.filter((item) => item?.status === index);
    setFilteredPatients(filtered);
    console.log("Filtered Patients:", filteredPatients);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const newPatients = Array.from(patient);
    const [movedPatient] = newPatients.splice(result.source.index, 1);
    newPatients.splice(result.destination.index, 0, movedPatient);
    setPatients(newPatients);
  };
  useEffect(() => {
    console.log("Updated patient order:", patient);
  }, [patient]);

  const imagePath = { Queue, Arrival, Hold, Done, Consult };
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isMedicineViewOpen, setIsMedicineViewOpen] = useState(false);

  const handleMedicineViewClick = (patient='') => {
    setIsMedicineViewOpen(true);
    setSelectedPatient(patient);
  };
  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: "topRight", // <-- key part for right side
  });
  const [messageApi, contextHolder] = message.useMessage();

  const updateAppointments = async (patient, status) => {
    const patient1 = { ...patient, status: status, _method: "put" };
    try {
      const result = await updateAppointment(patient1);
      if (result.success) {
        messageApi.open({
          type: "success",
          content: "Status updated successfully",
        });
      } else {
        console.error("Status Updation failed:", result.error);
        // Display error messages...
      }
    } catch (err) {
      console.error("Failed to update doctor:", err);
      messageApi.open({
        type: "error",
        content: "Failed to update doctor. Please try again.",
      });
    }
  };

  const handlePrev = () => {
    setSelectedDate((prev) => prev.subtract(1, "day"));
  };

  const handleNext = () => {
    setSelectedDate((prev) => prev.add(1, "day"));
  };
  const customFormat = (value) => {
    return dayjs().isSame(value, "day")
      ? "Today, " + value.format("YYYY")
      : value.format("D MMM YYYY");
  };

  const feeBreakupContent = (fee) => {
    // Convert fee (created_at) into a Date and format it
    const formattedTime = new Date(fee).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return (
      <div className="fee-breakup-popover">
        <h4 className="mb-3">
          <ClockCircleOutlined /> Arrival{" "}
          <span
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              padding: "2px 6px",
              borderRadius: "4px",
              fontWeight: "bold",
            }}
          >
            Late
          </span>
        </h4>
        <div className="d-flex justify-content-between mb-2 ">
          <span>{formattedTime}</span>
        </div>
      </div>
    );
  };
  const refreshdata = () => {
    setRefresh((prev) => !prev);
  };


  return (
    <>
      <Header refresh={refreshdata} />
      <Sidebar activeClassName="receptionist-dashboard" />
      <>
        {contextHolder}
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center g-1 scroll-container">
                {/* Breadcrumb */}
                <div className="col-lg-4 col-md-6 col-sm-12 breadcumcolumn">
                  <ul className="breadcrumb mb-2 mb-md-0">
                    <li className="breadcrumb-item">
                      <Link to="/pharmacy-dashboard">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <FeatherIcon icon="chevron-right" />
                    </li>
                    <li className="breadcrumb-item active">
                      Pharmacy Dashboard
                    </li>
                  </ul>
                </div>

                {/* Previous Button */}
                <div className="col-auto text-center">
                  
                </div>

                {/* Date Picker + Refresh */}
                <div className="col-md-3 col-sm-6 text-center d-flex justify-content-center">
                  <Link
                    to="#"
                    onClick={() => handlePrev()}
                    className="btn btn-rounded text-center"
                  >
                    <DoubleLeftOutlined className="fs-4" />
                  </Link>
                  <DatePicker
                    className="btn  text-center me-2"
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    format="DD-MM-YYYY"
                    allowClear={false}
                    style={{ background: "white", minWidth: "120px" }}
                  />
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => setRefresh((prev) => !prev)}
                    style={{
                      background: "white",
                      height: "36px",
                      width: "36px",
                    }}
                  />
                  <Link
                    to="#"
                    onClick={() => handleNext()}
                    className="btn btn-rounded text-center"
                  >
                    <DoubleRightOutlined className="fs-4" />
                  </Link>
                </div>

                {/* Next Button */}
                <div className="col-auto text-center">
                  
                </div>
              </div>
            </div>

            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="good-morning">
                      <div className="doctor-list-blk">
                        <Row
                          gutter={[16, 16]}
                          className="flex-nowrap"
                          style={{
                            overflowX: "auto",
                            overflowY: "hidden",
                            WebkitOverflowScrolling: "touch",
                            scrollbarWidth: "none", // For Firefox
                            msOverflowStyle: "none", // For IE/Edge
                            paddingBottom: "10px", // Space for selection border/shadows
                          }}
                        >
                          {Object.entries(count)
                            .filter(([title]) => title !== "total")
                            .map(([title, value], index) => (
                              <Col
                                key={index}
                                xs={12}
                                sm={8}
                                md={6}
                                lg={4}
                                className={`doctor-column `}
                                onClick={() =>
                                  setOnSelectedIndex(title.toString())
                                }
                                style={{ padding: "0px 8px 0px 0px" }}
                              >
                                <div
                                  className={`doctor-widget border-right-bg doctor-column ${
                                    selectedIndex === title ? "selected" : ""
                                  }`}
                                >
                                  <div
                                    className="doctor-box-icon flex-shrink-0"
                                    style={{
                                      background: "rgba(46, 55, 164, 0.05)",
                                      height: isSmallScreen ? "40px" : "55px",
                                      width: isSmallScreen ? "40px" : "55px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={imagePath[title]}
                                      alt=""
                                      style={{
                                        height: isSmallScreen ? "60%" : "70%",
                                        width: isSmallScreen ? "60%" : "70%",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>

                                  <div className="doctor-content dash-count flex-grow-1">
                                    <h4
                                      style={{
                                        fontSize: isSmallScreen
                                          ? "14px"
                                          : "18px",
                                      }}
                                    >
                                      <CountUp
                                        delay={0.4}
                                        end={value || 0}
                                        duration={0.6}
                                      />
                                      <span
                                        className="counter-up"
                                        style={{
                                          marginLeft: "5px",
                                          fontSize: isSmallScreen
                                            ? "10px"
                                            : "12px",
                                          color: "rgb(51 52 72 / 40%)",
                                        }}
                                      >
                                        /{count.total || 0}
                                      </span>
                                    </h4>
                                    <span
                                      className="font-weight-bold"
                                      style={{
                                        fontSize: isSmallScreen
                                          ? "14px"
                                          : "20px",
                                        fontWeight: "600",
                                        color: "#2e37a4",
                                      }}
                                    >
                                      {title}
                                    </span>
                                  </div>
                                </div>
                              </Col>
                            ))}
                        </Row>
                      </div>
                    </div>
                    <div className="table-responsive doctor-list">

                      {filteredPatients.length >= 1 ? (
                        <div
                          className="table-responsive"
                          style={{ minWidth: "max-content" }}
                        >
                          <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="patients">
                              {(provided) => (
                                <table
                                  className="table table-hover mt-50"
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  <thead
                                    style={{
                                      borderBottom:
                                        "2px solid rgb(225, 224, 230)",
                                      borderTop: "2px solid rgb(225, 224, 230)",
                                      position: "sticky",
                                    }}
                                  >
                                    <th></th>
                                    <th>
                                      <div className="text-muted ">PATIENT</div>
                                    </th>
                                    <th>
                                      <div className="text-muted ">CONTACT</div>
                                    </th>
                                    <th>
                                      <div className="text-muted ">Medicine</div>
                                    </th>
                                    <th>
                                      <div className="text-muted ">Action</div>
                                    </th>
                                  </thead>

                                  <tbody>
                                    {filteredPatients.map((patient, index) => (
                                      <Draggable
                                        key={patient.id.toString()}
                                        draggableId={patient.id.toString()}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <tr
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`${
                                              index % 2 === 0 ? "bg-light" : ""
                                            } ${
                                              snapshot.isDragging
                                                ? "dragging-row"
                                                : ""
                                            }`}
                                            style={{
                                              ...provided.draggableProps.style,
                                              display: snapshot.isDragging
                                                ? "table-row"
                                                : undefined,
                                              background: snapshot.isDragging
                                                ? "#f0f8ff"
                                                : "", // Optional highlight
                                              width: "100%", // Ensure full width
                                            }}
                                          >
                                            <td
                                              className="align-middle"
                                              style={{ width: "max-content" }}
                                            >
                                              <div className="d-flex align-items-center">
                                                <span className="me-2">
                                                  {index + 1}
                                                </span>
                                                <span className="text-secondary">
                                                  ≡
                                                </span>
                                              </div>
                                            </td>

                                            <td
                                              className="align-middle"
                                              style={{ width: "max-content" }}
                                            >
                                              <div>
                                                <Link
                                                  to="#"
                                                  className="fw-bold text-decoration-none"
                                                  style={{ color: "#2e37a4" }}
                                                >
                                                  {patient?.patient?.full_name}
                                                </Link>
                                                <div className="text-muted small">
                                                  {patient?.patient?.gender},{" "}
                                                  {patient?.patient?.age}
                                                </div>
                                              </div>
                                            </td>

                                            <td
                                              className="align-middle"
                                              style={{ width: "max-content" }}
                                            >
                                              <div>
                                                {patient?.patient?.mobile}
                                              </div>
                                            </td>
                                            
                                            <td
                                              className="align-middle"
                                              style={{ width: "max-content" }}
                                            >
                                              <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                onClick={() =>
                                                  handleMedicineViewClick(patient)
                                                }
                                              >
                                                View
                                              </button>
                                            </td>

                                            <td
                                              className="align-middle"
                                              style={{ width: "150px" }}
                                            >
                                              Done
                                            </td>
                                          </tr>
                                        )}
                                      </Draggable>
                                    ))}

                                    {provided.placeholder}
                                  </tbody>
                                </table>
                              )}
                            </Droppable>
                          </DragDropContext>
                        </div>
                      ) : (
                        <div className="content-area">
                          <p className="text-muted fs-5">
                            No appointments found for the selected criteria.
                          </p>
                        </div>
                      )}

                      {isMedicineViewOpen && (
                        <MedicineViewModal
                          isOpen={isMedicineViewOpen}
                          onClose={() => setIsMedicineViewOpen(false)}
                          patientData={selectedPatient}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Pharmacy_Dashboard;

//for earnings
{
  /*<div className="col-xl-2 col-md-6">
                  <div className="doctor-widget">
                    <div className="doctor-box-icon flex-shrink-0">
                      <img src={doctor_dashboard_04} alt="" />
                    </div>
                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        $ <CountUp delay={0.4} end={530} duration={0.6} />
                        <span className="status-green">+50%</span>
                      </h4>
                      <h5>Earnings</h5>
                      <p>
                        <span className="passive-view">
                          <i className="feather-arrow-up-right me-1" />
                          30%
                        </span>{" "}
                        vs last month
                      </p> 
                    </div>
                  </div>
                </div>*/
}
